import './version';
export * from './components/FocusZone/index';
//# sourceMappingURL=index.js.map